import uuid from 'react-uuid'

export const formatCreateAgentInput = async (
  agentValue: any,
  arrayOfAgentsToGetLeaderCode: any
) => {
  let agentArray = agentValue?.map(function (item: any) {
    if (item.id >= 0) {
      delete item.id
    }
    return item
  })
  if (agentArray.some((agent: any) => Boolean(agent.agentLeaderCode))) {
    agentArray = agentArray.map((agent: any) => {
      if (Boolean(agent.agentLeaderCode)) {
        return {
          ...agent,
          agentLeaderCode: arrayOfAgentsToGetLeaderCode.filter(
            ({ leaderCode }: any) => leaderCode === agent.agentLeaderCode
          )[0]?.leaderId,
        }
      } else {
        return agent
      }
    })
  }
  return agentArray
}
export const createAgentHelper = async (
  agentValue: any,
  arrayOfAgentsToGetLeaderCode: any,
  setGenerateTrackId: any,
  createAgents: any,
  uploadAgent: any,
  salesChannelId: any
) => {
  const agentArray = await formatCreateAgentInput(agentValue, arrayOfAgentsToGetLeaderCode)
  //call the createAgents API if agents < 10
  if (agentArray !== undefined && agentArray?.length <= 10) {
    const payload = agentArray.map((agent: any) => {
      return {
        emailId: agent?.agentEmailID,
        firstName: agent?.agentFirstName,
        lastName: agent?.agentLastName,
        leaderId: agent?.agentLeaderCode,
        repId: agent?.agentRepId,
      }
    })
    // Sync Call
    await createAgents({
      variables: {
        createAgentInputs: payload,
        salesChannelId: salesChannelId,
      },
    })
  }
  ///call the upload agents API if agents > 10
  if (agentArray !== undefined && agentArray?.length > 10) {
    const generatedTrackId = uuid()
    setGenerateTrackId(generatedTrackId)
    await uploadAgent({
      variables: {
        isVerified: true,
        salesChannelId: salesChannelId,
        trackId: generatedTrackId,
        userData: agentArray,
      },
    })
  }
}
